<template>
    <div>
        <iframe :src="`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(file_url)}`" class="iframe-player" :class="origin === 'library' ? 'player-library' : ''"></iframe>
    </div>
</template>

<script>
export default {
    props: ['file_url', 'origin']
}
</script>

<style lang="scss" scoped>
.iframe-player {
	width: 100%;
	height: 60vh;
	border: none;
}
@media (min-width: $breakpoint-sm-min) {
	.player-library {
   		height: 45vh;
	}
}
@media (min-width: $breakpoint-lg-min) {
	.player-library {
   		height: 50vh;
	}
}
</style>
